var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-dot flex-center",class:{'color-dot--selected': _vm.selected},on:{"click":function($event){_vm.$emit('click')}}},[_c('div',{staticClass:"color-dot__core",style:({'background-color': _vm.color})})])}
var staticRenderFns = []

export { render, staticRenderFns }